export default __webpack_public_path__ + "static/media/gacha-cocoon.671ed759.mp4";